import { LotResponse } from '@nx/api'
import { FireButton } from '@nx/fire/button'
import { buildLotPath } from '@nx/helpers'
import { getTranslate } from '@nx/translations'

import {
  ChevronLeft,
  ChevronRight,
  LotNavigationContainer,
  LotNavigationNext,
  LotNavigationPrevious,
} from './Navigation.styles'
import translate from './Navigation.translate.json'

const { text } = getTranslate(translate)

export const Navigation = ({ lot, auctionSaleNumber }: NavigationProps) => {
  return (
    <LotNavigationContainer>
      <LotNavigationPrevious>
        {lot.prev_next_lot.prev_lot && (
          <FireButton
            variant="label"
            href={buildLotPath({
              auctionId: auctionSaleNumber,
              lotId: lot.prev_next_lot.prev_lot.id,
              lotName: lot.prev_next_lot.prev_lot.desc,
              isPreview: lot.prev_next_lot.is_preview_lot,
            })}
            startIcon={(props) => <ChevronLeft {...props} />}
          >
            {text('previousLot')}
          </FireButton>
        )}
      </LotNavigationPrevious>
      <LotNavigationNext>
        {lot.prev_next_lot.next_lot && (
          <FireButton
            variant="label"
            href={buildLotPath({
              auctionId: auctionSaleNumber,
              lotId: lot.prev_next_lot.next_lot.id,
              lotName: lot.prev_next_lot.next_lot.desc,
              isPreview: lot.prev_next_lot.is_preview_lot,
            })}
            endIcon={(props) => <ChevronRight {...props} />}
          >
            {text('nextLot')}
          </FireButton>
        )}
      </LotNavigationNext>
    </LotNavigationContainer>
  )
}

export interface NavigationProps {
  lot: LotResponse
  auctionSaleNumber: number
}
